import { render, staticRenderFns } from "./BrandCentersUser.vue?vue&type=template&id=6aea5ae8&scoped=true&"
import script from "./BrandCentersUser.vue?vue&type=script&lang=js&"
export * from "./BrandCentersUser.vue?vue&type=script&lang=js&"
import style0 from "./BrandCentersUser.vue?vue&type=style&index=0&id=6aea5ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea5ae8",
  null
  
)

export default component.exports